const styles = {
  container: { 
    padding: "30px", 
    minHeight: "100vh", 
    backgroundColor: "#f4f6f9", 
    fontFamily: "Segoe UI, sans-serif",
    transition: "margin-left 0.3s ease"
  },
  header: { 
    color: "#1B019B", 
    fontWeight: "600", 
    fontSize: "1.5rem" 
  },
  hr: { 
    width: "80px", 
    border: "2px solid #1B019B", 
    opacity: "1", 
    margin: "10px auto" 
  },
  organisationHeader: {
    backgroundColor: '#fff', 
    padding: '20px', 
    borderRadius: '12px', 
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  filterContainer: {
    display: 'flex', 
    flexWrap: 'wrap', 
    alignItems: 'center', 
    gap: '15px', 
    marginBottom: '20px' 
  },
  filterGroup: {
    display: 'flex', 
    alignItems: 'center', 
    gap: '8px' 
  },
  filterIcon: {
    color: '#1B019B', 
    minWidth: '20px' 
  },
  searchBar: {
    borderRadius: '20px', 
    padding: '8px 15px', 
    border: '1px solid #ced4da', 
    fontSize: '1rem', 
    minWidth: '200px'
  },
  select: {
    borderRadius: '20px', 
    padding: '8px 15px', 
    border: '1px solid #ced4da', 
    fontSize: '1rem', 
    minWidth: '150px'
  },
  exportButton: {
    backgroundColor: '#dc3545', 
    color: 'white', 
    borderRadius: '20px', 
    padding: '8px 15px', 
    border: 'none', 
    display: 'inline-flex', 
    alignItems: 'center', 
    gap: '8px', 
    minWidth: '150px', 
    justifyContent: 'center'
  },
  tableHeader: {
    backgroundColor: '#1B019B', 
    color: '#fff' 
  },
  paginationButton: {
    backgroundColor: '#1B019B', 
    color: 'white', 
    border: 'none', 
    margin: '0 3px', 
    borderRadius: '5px', 
    padding: '5px 12px', 
    cursor: 'pointer'
  },
  paginationActive: {
    backgroundColor: '#0d0066', 
    color: 'white', 
    cursor: 'default'
  },
  paginationDisabled: {
    backgroundColor: '#e0e0e0', 
    color: '#a0a0a0', 
    cursor: 'not-allowed'
  },


  modalOverlay: { 
    position: "fixed", 
    top: 0, 
    left: 0, 
    width: "100vw", 
    height: "100vh", 
    backgroundColor: "rgba(0,0,0,0.5)", 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center", 
    zIndex: 1000 
  },
  modalContent: { 
    background: "#fff", 
    borderRadius: 16, 
    padding: 25, 
    maxWidth: 500, 
    width: "90%", 
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    textAlign: "center",
    position: 'relative'
  },
  modalImage: {
    maxWidth: '100%',
    maxHeight: '400px',
    borderRadius: '8px'
  },


  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    background: 'none',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
    color: '#555'
  },

  



  employeeName: {
    marginTop: '10px',
    fontWeight: '600',
    color: '#1B019B'
  },
photoCell: {
  width: '70px',
  padding: '5px',
},
photo: {
  width: '50px',
  height: '50px',
  borderRadius: '50%',
  objectFit: 'cover',
  cursor: 'pointer',
  transition: 'transform 0.2s, box-shadow 0.2s',
},
defaultPhoto: {
  width: '50px',
  height: '50px',
  borderRadius: '50%',
  backgroundColor: '#f0f0f0',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
},
motifButton: {
  background: 'none',
  border: 'none',
  color: '#1B019B',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
},

};

export default styles;